// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a9k5Q"};